import addMonths from 'date-fns/addMonths';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import { parseDdMmYyyy } from 'v2/formatters/date';
import * as Yup from 'yup';

const isValidExportDateRange = (value?: string[]) => {
  if (!value?.[0] || !value?.[1]) return false;

  const start = startOfDay(parseDdMmYyyy(value[0]));
  const end = startOfDay(parseDdMmYyyy(value[1]));
  const today = startOfDay(new Date());

  if (isBefore(end, start)) return false;
  if (isAfter(start, today) || isAfter(end, today)) return false;

  return !isAfter(end, startOfDay(addMonths(start, 12)));
};

export const FilterSchema = Yup.object().shape({
  date: Yup.mixed().test('period', 'Selecione um período de no máximo 12 meses', (value: string[]) =>
    isValidExportDateRange(value)
  ),
  email: Yup.string().nullable().email('Campo não é um e-mail válido')
});
